<template>
  <div class="conversation-detail-page" ref="conversationDetailPage">
    <div class="header d-flex align-center">
      <Button color="white" :to="backUrl">{{ $t('back') }}</Button>
      <div class="farm-name" :key="updated">{{ accName }}</div>
    </div>
    <infinite-loading direction="top" @infinite="infiniteHandler">
      <div slot="no-more"></div>
    </infinite-loading>
    <div class="conversation-list" id="conversation-list" :key="updated">
      <ConversationSpeechBubble
        v-for="message in this.list"
        :key="message.id"
        :message="message"
        @scrollBottom="scrollBottom"
        @lightbox="setLightbox"
        :hiddenLabel="hiddenLabel"
      />
    </div>
    <ConversationInputFloat :on-send="send" />

    <v-dialog max-width="100%" v-model="lightbox">
      <v-card>
        <v-card-title class="d-flex justify-end">
          <div @click="lightbox = false" style="cursor: pointer">&times;</div>
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <img :src="lightboxImg" class="ma-4" style="max-width: 100%; max-height: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Button from "@/components/shop/Button.vue";
import ConversationSpeechBubble from "@/components/shared/Conversations/ConversationSpeechBubble.vue";
import ConversationInputFloat from "@/components/shared/Conversations/ConversationInputFloat.vue";

export default {
  components: {
    Button,
    ConversationSpeechBubble,
    ConversationInputFloat,
    InfiniteLoading
  },

  props: {
    hiddenLabel: Boolean
  },

  data() {
    return {
      accType: this.$route.matched[1].name,
      conversationId: +this.$route.params.conversationId,
      lastId: 0,
      updated: 0,
      accName: "",
      interval: null,
      lightbox: false,
      lightboxImg: null,
      list: []
    };
  },

  computed: {
    backUrl() {
      return `/${this.accType.toLowerCase()}/conversations`;
    },
    conversations() {
      return this.$store.state.conversations.listArr;
    },
    getAccType() {
      return this.accType === "Farm" ? "shop" : "farm";
    },
  },

  async created() {
    const store = this.$store.state.conversations;

    if (!store.list[this.conversationId]) {
      await this.$store.dispatch("conversations/getConversations");
    }

    this.accName = store.list[this.conversationId][this.getAccType].name;

    await this.loadData();

    const target = document.getElementById("conversation-list");
    target.scrollIntoView(false);
  },

  destroyed() {
    clearInterval(this.interval);
  },

  methods: {
    async infiniteHandler($state) {
      let loaded_messages = [];
      if (!this.list.length) {
        await this.loadData();
        loaded_messages = this.messages();
      } else {
        const setBusy = false;
        const before_id = this.list[0].id;

        const response = await this.$http("get", `/conversations/${this.conversationId}/messages?count=20&before_id=${before_id}`, null, setBusy);

        if (response.status === 200) {
          loaded_messages = response.result.messages;
        }
      }

      loaded_messages.forEach(msg => {
        if (!this.list.reverse().find(x => x.id === msg.id)) {
          this.list.push(msg);
          this.list.sort((a, b) => a.id - b.id);
        }
      });

      if (loaded_messages.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    messages() {
      const { list } = this.$store.state.conversations;
      return list[this.conversationId] && list[this.conversationId].messages;
    },

    setLightbox(img) {
      this.lightbox = true;
      this.lightboxImg = img;
    },

    async loadData(fromInterval) {
      await this.$store.dispatch(
        "conversations/getMessages",
        this.conversationId
      );

      this.updated++;

      if (!fromInterval) {
        this.scrollBottom();
      }
    },

    async send({ body, image }) {
      await this.$store.dispatch("conversations/postMessage", {
        conversationId: this.conversationId,
        body,
        image
      });

      this.loadData();
      this.list.push(this.messages().pop());
    },

    async scrollBottom() {
      this.$refs.conversationDetailPage.scrollTop = this.$refs.conversationDetailPage.scrollHeight;
    }

  }
};
</script>

<style lang="scss" scoped>
.conversation-detail-page {
  display: grid;
  grid-template-rows: auto 1fr auto;
  background-color: #fff;
  padding: 0;
  height: calc(100vh - 70px);
  overflow: auto;
}

.header {
  border-bottom: #ccc 1px solid;
  padding: 16px 16px 8px;
  margin-top: 1px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
}

.farm-name {
  margin-left: 24px;
  color: #555;
  font-size: 18px;
  font-weight: bold;
}

.conversation-list {
  margin: 20px 32px;
  padding: 0 32px 30px;
  display: grid;
  grid-gap: 8px;
  align-content: start;

  @media screen and (max-width: 960px) {
    margin: 20px 0;
    padding: 0 16px;
  }
}
</style>
